import { render, staticRenderFns } from "./WaybillRequest.vue?vue&type=template&id=54ac1bd5&scoped=true&"
import script from "./WaybillRequest.vue?vue&type=script&lang=js&"
export * from "./WaybillRequest.vue?vue&type=script&lang=js&"
import style0 from "./WaybillRequest.vue?vue&type=style&index=0&id=54ac1bd5&scoped=true&lang=css&"
import style1 from "./WaybillRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac1bd5",
  null
  
)

export default component.exports